export enum USER_STATUS {
  ACTIVE = 1,
  INACTIVE = 2
}
